export default "__VITE_ASSET__Bip_qHB4__"